import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import WalletBalanceCard from "./WalletBalanceCard";
import { FaLock } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";
import { fetchProfile } from "../Services/profile/profileservice";
import { logout } from "../Services/authService";
import { IoNotificationsSharp } from "react-icons/io5";
import { removeToken } from "../utils/tokenUtils";
import { Fade as Hamburger } from "hamburger-react";
import VoiceControl from "../Layouts/Header/VoiceControl";
import ModalWithPinInput from "../Pages/LoginPages/ModalWithPinLock";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../Layouts/Header/Sidebar";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import { FaDownload } from "react-icons/fa";
import { BsArrow90DegRight, BsArrowRight } from "react-icons/bs";
import { CgArrowRight } from "react-icons/cg";
import {
  Bell,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Download,
  Lock,
  LogOutIcon,
  User2,
} from "lucide-react";

const Header = ({ heading, value }) => {
  const [profile, setProfile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [profileImg, setProfileImg] = useState('');
  const [loading, setLoading] = useState(false);
  const [filename, setFilename] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const navigate = useNavigate();
  const [countData, setCountData] = useState("");
  const [isChevronClicked, setIsChevronClicked] = useState(false);

  const fetchInProgress = useRef(false);
  const lastStatusRef = useRef(null);

  const fetchProfileData = async () => {
    // Prevent overlapping fetches (but allow new ones later)
    if (fetchInProgress.current) return;
    fetchInProgress.current = true;

    setLoading(true);
    try {
      const profileData = await fetchProfile();
      setProfile(profileData?.data || profileData || "");
      setCountData(profileData || "");
      const { status_id, name } = profileData?.data || {};
      if (lastStatusRef.current === status_id) return;
      lastStatusRef.current = status_id;

      if (!name) {
        navigate("/CompleteProfile");
      } else if ([1, 3, 16].includes(status_id)) {
        // Pending / Rejected / Hold
        setShowApprovalModal(true);
      } else if (status_id === 17) {
        // REKYC
        navigate("/CompleteProfile");
      } else if (status_id === 2) {
      } else {
      }
    } catch (err) {
      console.error("❌ Error fetching profile:", err);
    } finally {
      setLoading(false);
      fetchInProgress.current = false; // allow future calls safely
    }
  };

  //  Only run once at mount (and safe in Strict Mode)
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchProfileData();
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen().then(() => {
        setIsFullscreen(true);
      });
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
      });
    }
  };

  const handleCloseTop = () => {
    const sidebarMain = document.querySelector(".siderbar_main");
    const mainComponent = document.querySelector("#main_component");
    const width = window.innerWidth;
    if (width <= 1024) {
      sidebarMain.classList.toggle("sidemar_main_3");
    } else {
      sidebarMain.classList.toggle("sidemar_main_2");
      mainComponent.classList.toggle("main_component2");
    }
  };

  const handleLogout = async () => {
    const response = await logout();
    if (response.status === "success") {
      removeToken();
      window.location.href = "/Session-expired";
    } else {
      removeToken();
      window.location.href = "/Session-expired";
    }
  };

  const toggleModal = () => {
    //setIsModalOpen(prev => !prev);
    return;
  };

  const handlePinSubmit = (pin) => {
    toggleModal(); // Close the modal after submission
  };

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleProfileClick = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleLockScreen = () => {
    localStorage.setItem("isLock", true);
    navigate("/LockScreen");
    <Sidebar />;
  };

  return (
    <>
      {/* Modal component with props */}
      <ModalWithPinInput
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        correctPin="123456"
        onPinSubmit={handlePinSubmit}
      />

      {showApprovalModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 animate-fadeIn">
          <div className="bg-gradient-to-b from-white to-gray-100 p-6 rounded-xl shadow-2xl border border-gray-200 max-w-md w-11/12 text-left transform scale-95 animate-scaleUp">
            {/* ICON */}

            <div className="flex items-center justify-between mb-1">
              {/* LEFT EMPTY SPACE (to balance center) */}
              <div className="w-16"></div>

              {/* ICON CENTER */}
              <div className="flex justify-center flex-1">
                <svg
                  className={`w-16 h-16 ${
                    profile?.status_id === 1
                      ? "text-yellow-500"
                      : profile?.status_id === 3
                        ? "text-red-600"
                        : "text-orange-500"
                  } animate-bounce`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              {/* BUTTON RIGHT */}
              <div className="w-32 flex justify-end">
                <Link
                  to="/CompleteProfile"
                  className="px-1 py-1 bg-green-600 hover:bg-blue-700 text-white text-md rounded-lg transition-all"
                >
                  Complete Profile
                </Link>
              </div>
            </div>

            {/* TITLE */}
            <h2 className="text-2xl font-bold text-gray-800 mb-3 text-center">
              {profile?.status_id === 1 && "Pending Approval"}
              {profile?.status_id === 3 && "Application Rejected"}
              {profile?.status_id === 16 && "Profile On Hold"}
            </h2>

            {/* MESSAGE */}
            <p
              className={`leading-relaxed p-2 rounded-md shadow-xl border ${
                profile?.status_id === 1
                  ? "bg-blue-500 text-white border-blue-700"
                  : profile?.status_id === 3
                    ? "bg-red-500 text-white border-red-700"
                    : "bg-yellow-400 text-black border-yellow-600"
              }`}
            >
              <span className="font-semibold">
                {profile?.name || ""} (API ID: {profile?.user_id || ""})
              </span>
              <br />

              {/* STATUS */}
              {profile?.status_id === 1 && (
                <>
                  <span className="text-white font-semibold">
                    Status:{" "}
                    <u className="font-bold text-lg">Pending for Approval</u>
                  </span>
                  <br />
                  <br />
                  Your account will be activated within <b>
                    1 working day
                  </b>{" "}
                  (excluding holidays). In case of any delay, please contact
                  your SM at:
                  <br />
                  <b className="text-white text-xl">+91 91137 22202</b>
                </>
              )}

              {profile?.status_id === 3 && (
                <>
                  <span className="text-white font-semibold">
                    Status: <u className="font-bold text-lg">Rejected</u>
                  </span>
                  <br />
                  <br />
                  Your registration has been <b>rejected</b>. Please review your
                  submitted details or contact your SM for assistance.
                  <br />
                  <b className="text-white text-xl">+91 91137 22202</b>
                </>
              )}

              {profile?.status_id === 16 && (
                <>
                  <span className="text-black font-semibold">
                    Status: <u className="font-bold text-lg">On Hold</u>
                  </span>
                  <br />
                  <br />
                  Your profile is currently <b>on hold</b>. Please wait for
                  further updates or contact your SM for clarification.
                  <br />
                  <b className="text-black text-xl">+91 91137 22202</b>
                </>
              )}
            </p>

            {/* BUTTON */}
            <div className="mt-5 text-center">
              <button
                className="px-6 py-2 bg-blue-700 hover:bg-blue-800 text-white rounded-full font-semibold transition transform hover:scale-105"
                onClick={() => setShowApprovalModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between mb-1 items-center relative bg-gradient-to-br from-blue-800 to-blue-900 text-white rounded-lg p-2">
        <div className="flex flex-col justify-end">
          <div className="flex justify-end items-center">
            <WalletBalanceCard />

            <div className="hidden md:block"></div>
          </div>
        </div>

        {/* nav toggle chevron button starts here */}

        <button
          type="button"
          onClick={() => setIsChevronClicked(!isChevronClicked)}
          className="flex chevron-bg sm:hidden justify-center bg-white/10 items-center w-fit h-fit p-2 rounded-full"
        >
          <ChevronsLeft className="chevron-icon" size={34} />
        </button>

        {/* this nav is for small screens */}
        {/* {isChevronClicked && ( */}
        <div
          className={`
    flex sm:hidden w-full h-full rounded-lg justify-around
    absolute top-0 left-0 gap-1 items-center sm:gap-2
    bg-gradient-to-br from-blue-800 to-blue-700
    z-[9999]
    transition-transform  duration-1000 ease-in-out
    ${isChevronClicked ? "translate-x-0 opacity-100" : "hidden"}
  `}
        >
          <div className="flex items-center cursor-pointer px-1 relative">
            <Link
              to="/NewsNotification"
              className="relative flex items-center  gap-2 rounded-full py-1 px-2 hover:bg-purple-700 bg-white/10"
            >
              <Bell className="text-3xl text-white" />

              {countData?.dashboard_news_count > 0 && (
                <span
                  className="
        absolute 
        -top-2 
        -right-2
        bg-red-600 
        text-white 
        text-[14px] 
        font-bold 
        w-5 
        h-5 
        flex 
        items-center 
        justify-center 
        rounded-full
        shadow-lg
      "
                >
                  {countData?.dashboard_news_count}
                </span>
              )}
            </Link>
          </div>

          <div className="hidden md:flex items-center px-1 py-0.5 gap-1 ">
            <Link
              to="/AppDownload"
              className="flex items-center hover:bg-purple-700  gap-2 rounded-full py-1 px-2 bg-white/10  text-white font-semibold transition duration-300"
            >
              <span className="hidden xl:flex ">App</span>
              <Download />
            </Link>
          </div>

          <div className=" flex items-center justify-center hover:bg-purple-700  gap-2 rounded-full py-1 px-2 bg-white/10 cursor-pointer  ">
            <p className="hidden xl:flex">Mic</p>
            <VoiceControl AddClass="" />
          </div>

          <button
            onClick={handleLockScreen}
            className=" md:flex flex items-center  gap-2 rounded-full py-1 px-2 bg-white/10 hover:bg-purple-700 hover:border-blue-700 cursor-pointer  p-0.5"
          >
            <Lock size={24} />
            <span className="text-md font-semibold hidden xl:flex">Lock</span>
          </button>

          <p
            onClick={toggleFullscreen}
            className=" md:flex flex items-center  gap-2 rounded-full py-1 px-2 bg-white/10 cursor-pointer hover:bg-purple-700 hover:border-blue-700  mx-1"
          >
            {isFullscreen ? (
              <span className="flex justify-center text-nowrap items-center  gap-2 ">
                <p className="hidden xl:flex items-center  gap-2 ">
                  {" "}
                  Exit Full Screen
                </p>
                <MdFullscreenExit size={24} />
              </span>
            ) : (
              <span className="flex justify-center text-nowrap items-center  gap-2 ">
                <p className="hidden xl:flex items-center  gap-2 ">
                  {" "}
                  Full Screen
                </p>
                <MdFullscreen size={24} />
              </span>
            )}
          </p>

          <div
            onClick={handleLogout}
            className=" md:flex items-centers hover:bg-purple-700 hover:border-blue-700 cursor-pointer rounded-md p-0.5"
          >
            <span className="text-md flex items-center gap-2 rounded-full py-1 px-2 bg-white/10  font-semibold">
              <p className="hidden md:flex">Logout</p>
              <LogOutIcon size={24} />
            </span>
          </div>
          <div className="relative" ref={dropdownRef}>
            <button
              type="button"
              onClick={handleProfileClick}
              className=" bg-white/10 rounded-full p-2 text-white"
            >
              <User2 />
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 bg-white rounded-md shadow-inner shadow-blue-900 w-48 z-50 text-center border border-blue-800">
                <div className="flex items-center px-4 py-2 font-bold text-gray-700 border-b cursor-pointer bg-slate-200 rounded-md hover:bg-gray-200 hover:rounded-full">
                  <img
                    loading="lazy"
                    className="rounded-full h-5 w-4 mr-1"
                    src="https://imgs.search.brave.com/Ozp8H9xD4gRnaxduvyGjvb7g-B8s9wrplgqbUI_1370/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tYXJr/ZXRwbGFjZS5jYW52/YS5jb20vN05YT2Mv/TUFEYWtJN05YT2Mv/Mi90bC9jYW52YS11/c2VyLWljb24tTUFE/YWtJN05YT2MucG5n"
                    alt="Profile"
                    onClick={handleProfileClick}
                  />
                  {profile ? profile.name : "Loading..."}
                </div>
                <div
                  className="flex items-center px-4 py-2 text-gray-700 cursor-pointer border-b font-semibold transform hover:bg-gray-200 hover:rounded-full"
                  onClick={toggleModal}
                >
                  <div className="flex " onClick={handleLockScreen}>
                    <FaLock size={20} className="mr-2" />
                    <p>Lock Screen</p>
                  </div>
                </div>

                <div className="flex items-center px-4 py-2 text-gray-700 cursor-pointer border-b font-semibold hover:bg-gray-200 hover:rounded-full">
                  <p
                    onClick={toggleFullscreen}
                    className="cursor-pointer hidden md:block mx-1"
                  >
                    {isFullscreen ? (
                      <MdFullscreenExit size={20} />
                    ) : (
                      <MdFullscreen size={20} />
                    )}
                  </p>
                  Full/Exit Screen
                </div>

                <div className="flex items-center px-1 py-1 text-gray-700 cursor-pointer text-center hover:bg-gray-200 hover:rounded-full font-semibold shadow-lg">
                  <a
                    href="/assets/images/IDSPay API.apk"
                    download
                    className="flex items-center gap-1 text-whit px-1 py-2 rounded-md transition duration-300"
                  >
                    <img
                      loading="lazy"
                      src="/assets/images/Ap.png"
                      alt="APK"
                      className="h-6 w-8 object-contain"
                    />
                    <p>App</p>
                  </a>
                </div>

                <div
                  className="flex items-center px-5 py-1 text-gray-700 cursor-pointer text-center hover:bg-gray-200 hover:rounded-full font-semibold shadow-lg"
                  onClick={handleLogout}
                >
                  <RiLogoutBoxLine size={26} className="mr-2" />
                  <p className="">Logout</p>
                </div>
                <div className="flex justify-center">
                  <VoiceControl />
                </div>
              </div>
            )}
          </div>

          {/* another nav toggle chevron button starts here */}

          <button
            type="button"
            onClick={() => setIsChevronClicked(!isChevronClicked)}
            className="flex md:hidden justify-center shadow-md shadow-black items-center bg-red-700 animate-pulse text-white w-fit h-fit p-2 rounded-full"
          >
            <ChevronsRight size={28} />
          </button>
        </div>
        {/* )} */}

        {/* this nav is for big screens */}
        <div className="sm:flex hidden gap-1 items-center sm:gap-2">
          <div className="flex items-center cursor-pointer px-1 relative">
            <Link
              to="/NewsNotification"
              className="relative flex items-center hover:bg-purple-700  gap-2 rounded-full py-1 px-2 bg-white/10"
            >
              <Bell className="text-3xl text-white" />

              {countData?.dashboard_news_count > 0 && (
                <span
                  className="
        absolute 
        -top-2 
        -right-2
        bg-red-600 
        text-white 
        text-[14px] 
        font-bold 
        w-5 
        h-5 
        flex 
        items-center 
        justify-center 
        rounded-full
        shadow-lg
      "
                >
                  {countData?.dashboard_news_count}
                </span>
              )}
            </Link>
          </div>

          <div className="hidden md:flex items-center px-1 py-0.5 gap-1 ">
            <Link
              to="/AppDownload"
              className="flex items-center hover:bg-purple-700 gap-2 rounded-full py-1 px-2 bg-white/10  text-white font-semibold transition duration-300"
            >
              <span className="hidden xl:flex ">App</span>
              <Download />
            </Link>
          </div>

          <div className=" flex items-center justify-center hover:bg-purple-700  gap-2 rounded-full py-1 px-2 bg-white/10 cursor-pointer  ">
            <p className="hidden xl:flex">Mic</p>
            <VoiceControl AddClass="" />
          </div>

          <button
            onClick={handleLockScreen}
            className=" md:flex flex items-center  gap-2 rounded-full py-1 px-2 bg-white/10 hover:bg-purple-700 hover:border-blue-700 cursor-pointer  p-0.5"
          >
            <Lock size={24} />
            <span className="text-md font-semibold hidden xl:flex">Lock</span>
          </button>

          <p
            onClick={toggleFullscreen}
            className=" md:flex flex items-center  gap-2 rounded-full py-1 px-2 bg-white/10 cursor-pointer hover:bg-purple-700 hover:border-blue-700  mx-1"
          >
            {isFullscreen ? (
              <span className="flex justify-center text-nowrap items-center  gap-2 ">
                <p className="hidden xl:flex items-center  gap-2 ">
                  {" "}
                  Exit Full Screen
                </p>
                <MdFullscreenExit size={24} />
              </span>
            ) : (
              <span className="flex justify-center text-nowrap items-center  gap-2 ">
                <p className="hidden xl:flex items-center  gap-2 ">
                  {" "}
                  Full Screen
                </p>
                <MdFullscreen size={24} />
              </span>
            )}
          </p>

          <div
            onClick={handleLogout}
            className=" md:flex items-centers hover:bg-purple-700 hover:border-blue-700 cursor-pointer rounded-md p-0.5"
          >
            <span className="text-md flex items-center gap-2 rounded-full py-1 px-2 bg-white/10  font-semibold">
              <p className="hidden md:flex">Logout</p>
              <LogOutIcon size={24} />
            </span>
          </div>
          <div className="relative" ref={dropdownRef}>
            <button
              type="button"
              onClick={handleProfileClick}
              className=" bg-white/10 rounded-full hover:bg-purple-700 p-2 text-white"
            >
              <User2 />
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 bg-white rounded-md shadow-inner shadow-blue-900 w-48 z-50 text-center border border-blue-800">
                <div className="flex items-center px-4 py-2 font-bold text-gray-700 border-b cursor-pointer bg-slate-200 rounded-md hover:bg-gray-200 hover:rounded-full">
                  <img
                    loading="lazy"
                    className="rounded-full h-5 w-4 mr-1"
                    src="https://imgs.search.brave.com/Ozp8H9xD4gRnaxduvyGjvb7g-B8s9wrplgqbUI_1370/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tYXJr/ZXRwbGFjZS5jYW52/YS5jb20vN05YT2Mv/TUFEYWtJN05YT2Mv/Mi90bC9jYW52YS11/c2VyLWljb24tTUFE/YWtJN05YT2MucG5n"
                    alt="Profile"
                    onClick={handleProfileClick}
                  />
                  {profile ? profile.name : "Loading..."}
                </div>
                <div
                  className="flex items-center px-4 py-2 text-gray-700 cursor-pointer border-b font-semibold transform hover:bg-gray-200 hover:rounded-full"
                  onClick={toggleModal}
                >
                  <div className="flex " onClick={handleLockScreen}>
                    <FaLock size={20} className="mr-2" />
                    <p>Lock Screen</p>
                  </div>
                </div>

                <div className="flex items-center px-4 py-2 text-gray-700 cursor-pointer border-b font-semibold hover:bg-gray-200 hover:rounded-full">
                  <p
                    onClick={toggleFullscreen}
                    className="cursor-pointer hidden md:block mx-1"
                  >
                    {isFullscreen ? (
                      <MdFullscreenExit size={20} />
                    ) : (
                      <MdFullscreen size={20} />
                    )}
                  </p>
                  Full/Exit Screen
                </div>

                <div className="flex items-center px-1 py-1 text-gray-700 cursor-pointer text-center hover:bg-gray-200 hover:rounded-full font-semibold shadow-lg">
                  <a
                    href="/assets/images/IDSPay API.apk"
                    download
                    className="flex items-center gap-1 text-whit px-1 py-2 rounded-md transition duration-300"
                  >
                    <img
                      loading="lazy"
                      src="/assets/images/Ap.png"
                      alt="APK"
                      className="h-6 w-8 object-contain"
                    />
                    <p>App</p>
                  </a>
                </div>

                <div
                  className="flex items-center px-5 py-1 text-gray-700 cursor-pointer text-center hover:bg-gray-200 hover:rounded-full font-semibold shadow-lg"
                  onClick={handleLogout}
                >
                  <RiLogoutBoxLine size={26} className="mr-2" />
                  <p className="">Logout</p>
                </div>
                <div className="flex justify-center">
                  <VoiceControl />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="">
        <marquee
          className="text-red-800 before_top_left_content w-56 sm:w-56 md:w-full lg:w-full"
          behavior=""
          direction="left"
        >
          Do not Share UserId & Password to Unauthorized Person.
        </marquee>
      </div>
      <hr />
      <div className="flex justify-between items-center">
        <div className="flex items-center p-0">
          <p onClick={handleCloseTop} className="menu_icon cursor-pointer">
            <Hamburger duration={0.8} className="text-xs md:text-md" />
          </p>
          <h1
            id="typewriter"
            className="company_name text-md md:text-lg font-bold text-gray-500"
          >
            {heading}
            {value}
          </h1>
        </div>
      </div>
      <hr />
    </>
  );
};

export default Header;
